import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { Button } from "@/components/ui/button";

export default function BuchungAbbruch() {
  return (
    <div className="min-h-screen bg-cream-50">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-36 pb-24">
        <div className="rounded-3xl bg-white border border-cream-300 shadow-soft p-10 text-center">
          <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-cream-200 text-sand-700 mb-2">
            <XCircle className="h-8 w-8" strokeWidth={1.8} />
          </div>
          <h1 className="mt-4 font-heading text-3xl md:text-4xl font-semibold text-sand-800">Buchung abgebrochen</h1>
          <p className="mt-3 text-sand-600 leading-relaxed">
            Kein Problem — es wurde nichts abgebucht. Wenn du Fragen hast, melde dich gern bei uns. Wir beraten dich kostenlos und finden den richtigen Kurs für dich.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild className="rounded-full bg-sand-800 text-cream-50 hover:bg-sand-700 h-12 px-7">
              <Link to="/#kurse">Zurück zu den Kursen <ArrowRight className="ml-2 h-4 w-4" strokeWidth={1.5} /></Link>
            </Button>
            <Button asChild variant="outline" className="rounded-full h-12 px-7 border-sand-400 text-sand-800 hover:bg-cream-200 bg-transparent">
              <Link to="/#kontakt">Beratung anfragen</Link>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
